import React from "react";
import { Link } from "react-router-dom";
import SideCartItem from "./components/SideCartItem";
import useCart from "../../hooks/useCart";
import VoidCartList from "../Cart/components/VoidCartList";
import { formatCurrency } from "../../util/formatters";
import { useAuth } from "../../hooks/useAuth";

const SideCart = ({ handleCloseCart, isOpen }) => {
  const { cart, totalValue, clearCart } = useCart();
  const { userInfo } = useAuth();
  const buyingLimitTotal = userInfo?.user_buying_limit ?? 0;
  const buyingLimitAvailable = userInfo?.user_buying_limit_available ?? 0;
  const buyingLimitUsedLast30Days =
    userInfo?.user_buying_limit_used_last_30_days ?? 0;

  const handleEmptyCart = () => {
    if (cart.length === 0) return;
    if (
      window.confirm(
        "Deseja remover todos os itens do carrinho? Esta ação não pode ser desfeita."
      )
    ) {
      clearCart();
      handleCloseCart?.();
    }
  };

  const isPurchaseDisabled = () => {
    return totalValue() > buyingLimitAvailable;
  };
  return (
    <>
      <div
        onMouseLeave={handleCloseCart}
        id="ltn__utilize-cart-menu "
        className={`ltn__utilize ltn__utilize-cart-menu ${isOpen ? "expanded" : ""
          }`}
        style={{
          boxShadow: "0 0 50px 0 rgba(46, 56, 220, 0.2)",
        }}
      >
        <div
          className="ltn__utilize-menu-inner"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          <div style={{ flexShrink: 0 }}>
            {isPurchaseDisabled() && (
              <div className="mini-cart-sub-total">
                <i className="fa-solid fa-triangle-exclamation ltn__secondary-color"></i>{" "}
                <strong>
                  Limite de compra excedido! Por favor remova items do carrinho
                  para prosseguir com a compra!
                </strong>
              </div>
            )}
            <div className="ltn__utilize-menu-head">
              <span className="ltn__utilize-menu-title">Carrinho</span>
              <div className="d-flex align-items-center">
                {cart.length > 0 && (
                  <button
                    type="button"
                    onClick={handleEmptyCart}
                    className="ltn__utilize-close"
                    aria-label="Esvaziar carrinho"
                    title="Esvaziar carrinho"
                    style={{
                      fontSize: "18px",
                      lineHeight: 1,
                      color: "var(--ltn__secondary-color, #071C1F)",
                      border: "none",
                    }}
                  >
                    <i className="fa-solid fa-trash-can" aria-hidden />
                  </button>
                )}
                <button
                  type="button"
                  onClick={handleCloseCart}
                  className="ltn__utilize-close"
                  title="Fechar carrinho"
                  aria-label="Fechar carrinho"
                >
                  ×
                </button>
              </div>
            </div>
          </div>

          {cart.length === 0 ? (
            <div
              className="ltn__scrollbar"
              style={{ flex: 1, minHeight: 0, overflowY: "auto" }}
            >
              <VoidCartList />
            </div>
          ) : (
            <div
              className="mini-cart-product-area ltn__scrollbar"
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                maxHeight: "none",
              }}
            >
              {cart.map((e) => (
                <SideCartItem key={e.product_id} obj={e} />
              ))}
            </div>
          )}

          {cart.length !== 0 && (
            <div
              className="mini-cart-footer"
              style={{
                flexShrink: 0,
                marginTop: 0,
                paddingTop: "8px",
              }}
            >
              <div className="mini-cart-sub-total">
                <h5 style={{ color: "#071C1F" }}>
                  Subtotal: <span>{formatCurrency(totalValue())}</span>
                </h5>
              </div>
              <div
                style={{
                  marginTop: "6px",
                  paddingTop: "6px",
                  borderTop: "1px solid #e5eaee",
                }}
              >
                <strong
                  style={{ fontSize: "12px", lineHeight: 1.35, color: "#6c757d" }}
                >
                  Limites:{" "}
                  <span style={{ color: "var(--bs-success, #198754)" }}>
                    Total: {formatCurrency(buyingLimitTotal)}
                  </span>{" "}
                  |{" "}
                  <span
                    style={{
                      color:
                        buyingLimitAvailable > 0
                          ? "var(--bs-success, #198754)"
                          : "var(--ltn__secondary-color, #dc3545)",
                    }}
                  >
                    Disponivel: {formatCurrency(buyingLimitAvailable)}
                  </span>{" "}
                  |{" "}
                  <span >
                    Usado (30 dias): {formatCurrency(buyingLimitUsedLast30Days)}
                  </span>
                </strong>
              </div>

              <div className="btn-wrapper go-top">
                <Link
                  to="/carrinho"
                  className="theme-btn-1 btn btn-effect-1 p-4"
                  title="Ver carrinho"
                >
                  Ver Carrinho
                </Link>
                {
                  !isPurchaseDisabled() && (
                    <Link
                      to="/finalizar-pedido"
                      className="theme-btn-2 btn btn-effect-2 d-flex justify-content-center p-4"
                      title="Ir para o checkout"
                    >
                      Checkout
                    </Link>
                  )
                }
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default SideCart;
